import { useEffect, useState } from "react";
import { useAuth } from "../providers/AuthContext";
import { getAssignableLicenseOptionsByAgreement } from "../api/Licenses";

/**
 * The agreement's assignable licences as suggestions for an account type's licence part
 * number: `[{ value: mpn, label: "<mpn> — <name>" }]`. The MPN is repeated in the label
 * because browsers differ in whether a datalist shows the value beside the label.
 *
 * Loaded once per agreement. A failure only costs the suggestions — the field stays a
 * free-text field — so it is logged rather than shown to the user.
 */
const useAssignableLicenseOptions = (agreementPublicId) => {
  const { getAccessToken } = useAuth();
  const [licenseOptions, setLicenseOptions] = useState([]);

  useEffect(() => {
    if (!agreementPublicId) return;

    const loadLicenseOptions = async () => {
      try {
        const accessToken = await getAccessToken();
        const licenses = await getAssignableLicenseOptionsByAgreement(
          agreementPublicId,
          accessToken
        );
        setLicenseOptions(
          licenses.map((license) => ({
            value: license.mpn,
            label: `${license.mpn} — ${license.name}`,
          }))
        );
      } catch (error) {
        console.error("Failed to fetch assignable license options:", error);
      }
    };

    loadLicenseOptions();
    // getAccessToken is left out on purpose, as on the pages: it is not referentially
    // stable, and depending on it would refetch on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreementPublicId]);

  return licenseOptions;
};

export default useAssignableLicenseOptions;
